
<template>
    <div>
      <div class="background" id="backgroundId">
        <div class="goback">
            <img src="../../assets/countyQB/左箭头.png" alt="" style="position: absolute;;left: 0;top: 1px;width: 8px;height: 16px;">
            <div class="gobackText" @click="$router.push('/MyRSservice');">返回我的套件</div>
        </div>
        <div class="greyText1">购买专业版套件</div>
        <div class="jindutiao">
            <img src="../../assets/countyQB/蓝1.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 265px;width: 30px;height: 30px;">
            <div class="jindutiaoText1">需求确认</div>
            <div class="jindutiaoLine1"></div>
            <img src="../../assets/countyQB/蓝2.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 445px;width: 30px;height: 30px;">
            <div class="jindutiaoText2" style="color: #3a3a3a;">订单提交</div>
            <div class="jindutiaoText3">{{ submitTime }}</div>
            <div class="jindutiaoLine1" style="width: 150px;left: 475px;"></div>
            <img src="../../assets/countyQB/蓝3.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 625px;width: 30px;height: 30px;">
            <div class="jindutiaoText2" style="left: 602px;color: #3a3a3a;">合同已生成</div>
            <div class="jindutiaoText3" style="left:566px ;">{{ contractTime }}</div>
            <div class="jindutiaoLine1" style="width: 75px;left: 655px;"></div>
            <div class="jindutiaoLine2" style="width: 75px;left: 730px;"></div>
            <img src="../../assets/countyQB/灰4.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:805px;width: 30px;height: 30px;">
            <div class="jindutiaoText2" style="left: 782px;">交付</div>
            <div class="jindutiaoLine2" style="width: 150px;left: 835px;"></div>
            <img src="../../assets/countyQB/灰5.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:985px;width: 30px;height: 30px;">
            <div class="jindutiaoText2" style="left: 962px;">评价</div>
        </div>
        <!-- 电子合同 -->
        <div class="contract" id="contractId" v-if="eleOrPaper==1">
          <img
            src="../../assets/countyQB/合同已生成.png"
            alt=""
            class="contractIcon"
          />
          <div class="text1">
            您的订单
            <span
              style="color: #006699; font-family: PingFang SC; font-weight: 500"
              >{{requirementId}}</span
            >
            合同已生成
          </div>
          <div class="text2">
            您在提交订单时选择了电子合同，请您尽快确认合同内容。特别<span
              style="color: #ff4040"
              >提醒</span
            >您，在您点击确认之后，合同即生效且具备法律效力，受《合同法》保护。系统将自动安排数据生产任务。若您对合同内容有异议，请联系商务经理协助处理。
          </div>
          <div class="xuxian"></div>
          <div class="xuxian" style="left: 731px"></div>
          <div class="text3">请您仔细核对合同内容</div>
          <img
              src="../../assets/countyQB/核对合同.png"
              alt=""
              class="checkIcon"
            />
          <div class="pdfToPic" id="pdfToPicId">
            <div class="contentText1">订单编号：<span style="font-family:Arial;">{{requirementId}}</span></div>
            <div class="contentText2">吉林一号切片影像套件产品<br>服务合同</div>
            <div class="contentText4" style="margin-top: 410px;">购买方(甲方)：{{userClientName}}</div>
            <div class="contentText4">销售方(乙方)：长光卫星技术股份有限公司</div>
            <div class="contentText4">签订时间：{{startTime}}</div>
            <div class="contentText4">签订地点：吉林长春</div>
            <div class="contentText4">有效期限：{{startTime}} - {{endTime}}</div>

            <div class="contentText6" style="margin-top: 100px;text-align: center;font-size: 24px;">吉林一号切片影像套件产品服务合同</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 70px;">购买方（甲方）：{{ userClientName }}</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;">销售方（乙方）：长光卫星技术股份有限公司</div>
            <div class="contentText7" style="line-height: 35px;margin-top: 30px;">甲方经与乙方友好协商，依据《中华人民共和国民法典》等相关法律法规就乙方向甲方提供 {{ requestName }}吉林一号切片影像套件产品服务事宜于 {{ startTimeChinese }} 在中华人民共和国吉林省长春市签订合同如下：</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 5px;">甲方所选购产品的服务截止日期为 {{ endTimeChinese }}，服务期内甲方享有本合同规定的权益与义务。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 30px;">1、甲方权益与义务</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）在合同有效期内，甲方享有所购买产品的全部服务权益（服务内容以吉林一号遥感商城发布为准：https://www.jl1mall.com/rskit/）</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）甲方需妥善保管好本单位的密钥，不得转借给其他单位或个人使用，若发现任何包括但不限于非法使用专有账号或其他有安全问题的情况，应立即告知乙方。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）本产品仅供甲方单位使用，不得将产品密钥转卖给其他单位或个人。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（4）由甲方保管用户名和密码不善或泄露数据库信息所带来的损失，由甲方承担。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（5）甲方使用所购买产品不得损害国家和社会公共利益，产生后果由甲方承担。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（6）甲方应知悉产品调用权限和并发数权限，超出相关权限后访问将受限。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（7）甲方承诺不通过API向乙方计算机进行任何与本产品服务无关的恶意操作。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（8）甲方默认接受吉林一号遥感商城发布的《吉林一号遥感影像套件用户使用协议》全部条款：https://www.jl1mall.com/rskit/。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（9）甲方不得以任何形式爬取切片服务中的数据，并需要对甲方平台用户的爬取行为进行安全限制，不得默许甲方用户的爬取行为。如存在此类违规行为甲方需以本合同签订金额的10倍对乙方进行赔偿。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（10）未经乙方同意，甲方不得以分销形式直接销售乙方提供的切片数据服务。如存在此类违规行为甲方需以本合同签订金额的10倍对乙方进行赔偿。</div>

            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">2、乙方义务</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）甲方付款完成后，乙方应保证3个工作日内开始向甲方提供所购买产品服务。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）在合同有效期内，应保证甲方享有所购买产品的稳定服务，（服务内容以吉林一号遥感商城发布为准：https://www.jl1mall.com/rskit）。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）若产品出现变更等情况，乙方应及时在吉林一号遥感商城（https://www.jl1mall.com/rskit）公布，并保证甲方的权益直至有效期结束。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">3、付款方式</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">合同签订之日起 7日内,甲方向乙方支付合同款100%，即人民币 {{ payChinese }}整（小写：人民币 {{ payFinal }} 元）。乙方向甲方开具同等金额的正式增值税（6%）发票。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">4、验收</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">产品到服务截止日期后系统默认自动验收。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">5、知识产权</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">甲方在按照本合同约定的方式使用所购买产品（包括但不限于将合同数据用于商业服务、出版印刷、科学文献、商业杂志、宣传展示用幻灯片、透明片、图片等）时，均必须注明版权所有及数据年份等标识：© 2023长光卫星技术股份有限公司 版权所有。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">若甲方违反上述约定，应当独立承担因此引起的一切法律责任，应当赔偿乙方因此所遭受的一切损失。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">6、保密责任</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">甲方对于合同成果以及因履行本合同而知悉的乙方的商业秘密和技术秘密等信息承担保密责任，未经乙方事先书面同意，甲方不得向任何第三人披露、以任何形式使用或许可他人使用上述信息（法律或政府权力机构要求的除外）。甲方未遵守本条规定，给乙方造成损失的，甲方应当赔偿乙方因此所遭受的一切损失。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">7、违约责任</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">如果因乙方原因（不可抗力除外）延迟交付合同成果，每延迟五个工作日，按延迟交付成果金额的0.5%，乙方向甲方支付违约金。违约金总额累计不超出合同总额的5%。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">由于甲方原因，导致本合同不能完全或部分履行，甲方应当赔偿乙方因此所遭受的一切损失。损失包括乙方为甲方提供服务的单位时间内的人力费用和资产费用，数据处理系统的自然损耗费用等；乙方因调查甲方违约所支出的调查费用、律师费用、诉讼费用以及其他乙方认为必要的费用等。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">如果甲方不能按时向乙方支付应付合同款（因不可抗力原因导致的除外），每延误一日，甲方向乙方支付违约金,金额为该期付款总额的0.5%。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">8、“不可抗力”</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">“不可抗力事件”系指合同双方不能预见、不能预防、避免并克服的事件。“不可抗力事件”包括但不限于：恶劣天气、政府禁令或法令法规、大罢工、骚乱等，地震、海啸等自然灾害。当发生不可抗力，致使乙方无法全部或部分履行其义务时，乙方不承担任何违约责任。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">9、吉林一号遥感商城数据线上流程条款</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）吉林一号遥感商城账号注册时已进行实名认证，与使用者本人信息绑定，具有一一对应的唯一性，甲方对本人会员账号具有管理义务，需确保吉林一号生态开放商城会员账号为本人所用，若存在非本人操作情况，乙方不承担相应责任。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）甲方点击确认订单页“确认合同”按钮，视为甲乙双方同意有关交易条款，合同正式生效，该订单确认，并受《中华人民共和国民法典》保护。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）甲方套件产品服务期满即默认甲方已自动验收。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（4）甲方点击完成“评价”按钮可对本次服务进行评价。若甲方在手动或自动确认验收后 7 个日历天内未进行订单评价，系统将默认为订单进行自动好评，效力与乙方进行自主评价相同。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（5）甲方付款后，系统将根据用户在订单页的选择发票类型自动触发发票开具流程，若因甲方未及时下载或查收、信息填写错误造成发票失效作废，责任由甲方承担，乙方不重复开具。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">10、适用法律</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">本合同受中华人民共和国法律管辖。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">11、其它</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）本合同一式肆份，甲、乙双方各执贰份，自甲乙双方签字盖章之日起生效。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）如双方在本合同执行过程中发生争议，应本着平等互利的原则友好协商，如协商不成，任何一方均可向乙方所在地的人民法院提起诉讼。</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）本合同未尽事宜，双方协商解决。</div>
            <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">13、合同签署</div>
            <div class="contentText7" style="line-height: 30px;margin-top: 10px;">甲方在吉林一号遥感商城提供的区域矢量范围来源自网上公开数据，名称“县区图”产品为指代含义，甲方对该范围的准确性及范围更新不承担责任，若乙方在吉林一号遥感商城网页浏览该范围及确认本合同，即默认知晓该事项，并同意甲方提供该矢量范围内的数据服务。甲方对超出该范围的影像不承担提供和更新义务。</div>

            <!-- <div class="contentText10">
                <div class="contentText8" style="margin-left: 0px;margin-top: 0px;">甲方：{{ userClientName }}</div>
                <div class="contentText9" style="margin-right: 0px;margin-top: 0px;">乙方：长光卫星技术股份有限公司</div>
            </div>
            <div class="contentText8">盖<span style="padding-left: 2em;">章：</span></div>
            <div class="contentText9">盖<span style="padding-left: 2em;">章：</span></div>
            <div class="contentText8">授权代表（签字）：</div>
            <div class="contentText9">授权代表（签字）：</div>
            <div class="contentText8">签订日期：<span style="padding-left: 4em;">年</span> <span style="padding-left: 2em;">月</span>  <span style="padding-left: 2em;">日</span></div>
            <div class="contentText9">签订日期：<span style="padding-left: 4em;">年</span> <span style="padding-left: 2em;">月</span>  <span style="padding-left: 2em;">日</span></div>
            <div class="contentText8">联系电话：</div>
            <div class="contentText9">联系电话：</div>    -->
          </div>
          <img src="../../assets/countyQB/遮盖阴影.png" alt="" class="shadow" v-if="!isCheck">
          <div class="checkContract" @click="check()" v-if="!isCheck">查看并确认合同</div>
          <div class="confirmContract" v-if="isCheck" @click="tip=1">确认合同</div>
        </div>
        <!-- 纸质合同 -->
        <div class="contractPaper" v-if="eleOrPaper==0">
          <img
            src="../../assets/countyQB/合同已生成.png"
            alt=""
            class="contractIcon"
          />
          <div class="text1">您的订单<span style="color: #006699; font-family: PingFang SC; font-weight: 500">{{requirementId}}</span>合同已生成</div>
          <div class="text2" style="top: 266px;width: 820px;text-align: left;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在提交专业版套件订单时选择了纸质合同，请您尽快下载并确认合同内容，盖章(签字)后上传扫描件。同时您需要线下邮寄纸质版合同（邮寄地址：吉林省长春市北湖科技开发区明溪路1299号长光卫星技术股份有限公司，邮编：130000，电话: 0431-86008580，收件人：马先生）。
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特别<span style="color: #ff4040">提醒</span>您，在您上传合同扫描件并最终点击确认之后，合同即生效，且具备法律效力，受《合同法》保护。若您对合同内容有异议，请联系商务经理。</div>
          <div class="downloadContract" @click="load()">下载合同</div>
          <div class="downloadContract" style="background: #336699;color: #FFFFFF;top: 528px;"  @click="tip=3">上传扫描件</div>
          <div class="paperText1">请上传已盖章的合同扫描件</div>
          <div class="paperText1" style="top: 468px;">《吉林一号切片影像套件产品服务合同》</div>
        </div>
        <div class="contractTip">若您有任何疑问请咨询商务经理：0431-86008580</div>
      </div>
      <div class="footerWhite">
        <div class="text">
            © 2023-2026 长光卫星技术股份有限公司 版权所有 |
            <span @click="goPrivacyPolicy()" style="cursor: pointer">隐私协议</span>
            |
            <span @click="goServiceAgreement()" style="cursor: pointer"
            >服务条款</span
            >
        </div>
      </div>
      <div class="contractDialog" v-if="tip==1">
        <div class="white1">
          <div class="diglogText1">提示</div>
          <div class="diglogText3">再次提醒您确认：
            <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在您点击“一键确认”之后，合同即生效且具备法律效力，受《合同法》保护。若您对合同内容有异议，请联系商务经理协助处理；<span @click="tip=0" style="color: #006699;cursor: pointer;text-decoration:underline;">点击查看合同</span>
            <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 确认合同后请您尽快完成订单支付，以便我们给您交付套件。
            </div>
          <div class="dialog1Button2" style="top: 293px;left: calc(50% - 64px);" @click="confirmContract1()">一键确认</div>
        </div>
      </div>
      <div class="contractDialog" v-if="tip==2">
        <div class="white1">
          <div class="diglogText1">您已确认订单 {{requirementId}} 合同</div>
          <div class="diglogText2">请您尽快完成订单支付，以便我们给您交付套件。</div>
          <div class="dialog1Button1" @click="jumpToDetail()">查看订单详情</div>
          <div class="dialog1Button2" @click="jumpToPay()">立即付款</div>
        </div>
      </div>
      <div class="contractDialog" v-if="tip==3">
        <div class="white1">
          <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="tip=0;isUpload=false">
          <div class="diglogText1">请上传并确认</div>
          <div class="diglogText3">再次提醒您确认：
            <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在您点击“一键确认”之后，合同即生效且具备法律效力，受《合同法》保护。若您对合同内容有异议，请联系商务经理协助处理；<span @click="load()" style="color: #006699;cursor: pointer;text-decoration:underline;">点击下载合同</span>
            <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 确认合同后请您尽快完成订单支付，以便我们给您交付套件。
          </div>
          <input
          type="file"
          class="fileUpload"
          name="file"
          id="file"
          @input="fileChange"
          />
          <img
            src="../../assets/countyQB/上传合同扫描件.png"
            alt=""
            class="paperIcon"
            v-if="!isUpload"
          />
          <div class="paperText" v-if="!isUpload">上传合同扫描件</div>
          <div class="paperText2" v-if="isUpload">{{fileName}}</div>
          <div class="paperConfirm" id="paperConfirmId" @click="confirmContract2()">一键确认</div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "countyContract",
    data() {
      return {
        requirementId:"",
        //提交订单时间
        submitTime:"",
        //合同生成时间
        contractTime:"",
        //判断是电子合同还是纸质合同
        eleOrPaper:1,
        isCheck:false,
        tip:0,
        userClientName:"",
        startTime:"",
        startTimeChinese:'',
        endTime:"",
        endTimeChinese:"",
        county:"",
        quarter:"",
        payFinal:"",
        payChinese:"",
        contractUrl:"",
        requestName:'',
        //判断纸质合同扫描件是否上传
        isUpload:false,
        fileName:"",
        file:[]

      };
    },
    methods: {
      getKey() {
        return localStorage.getItem("token");
      },
      toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
      goPrivacyPolicy() {
            window.open("http://jl1mall.com/PrivacyPolicy", "_self");
        },
      goServiceAgreement() {
          window.open("http://jl1mall.com/ServiceAgreement", "_self");
      },
      //获取合同信息
      getContract(){
        this.requirementId=this.$route.query.id;
        let param = new FormData();
        param.append("orderId", this.requirementId);
        this.axios
            .post(
              "/tilesapi/tiles/register/queryContract",
              param,
              {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }
            )
            .then((res) => {
              console.log(res.data)
              let data = res.data.data
              if(data.type=="电子"){
                this.eleOrPaper=1
                this.userClientName=data.userClientName
                let year = data.startTime.substring(0,4)
                let month = data.startTime.substring(5,7)
                let day = data.startTime.substring(8,10)
                this.startTime=year+'.'+month+'.'+day
                this.startTimeChinese=year+'年'+month+'月'+day+'日'
                let year1 = data.endTime.substring(0,4)
                let month1 = data.endTime.substring(5,7)
                let day1 = data.endTime.substring(8,10)
                this.endTime=year1+'.'+month1+'.'+day1
                this.endTimeChinese=year1+'年'+month1+'月'+day1+'日'
                this.payFinal=data.payFinal
                this.payChinese=data.payChinese
                this.quarter=data.quarter
                this.county=data.countyName
                this.requestName=data.requestName
                console.log(this.county);
              }else if(data.type=="纸质"){
                this.eleOrPaper=0
                let backgroundId =document.getElementById("backgroundId")
                backgroundId.style.height="5300px"
                this.contractUrl=data.url
              }

            });
      },
      //消除js计算误差add、reduce是传入的加减数字,reduce是被加数（被减数），s是加减符号
      formatNum(add, reduce, s, num) {
        let m = Math.pow(10, num); //num是10的次幂
        let res = s == '+' ? (add * m + reduce * m) / m : (add * m - reduce * m) / m;
        return Math.round(res * m)/m;
      },
      //获取状态时间信息
      getStatusTime(){
        this.requirementId=this.$route.query.id;
        this.axios.get("/tilesapi/tiles/county/order/queryCountyOrderByOrderId?orderId=" + this.requirementId, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res) => {
                console.log(res);
                let data =res.data.data
                this.submitTime=data.createTime
                this.contractTime=data.contractGenerateTime
            })

      },
      check(){
          this.isCheck=true
          let pdfToPicId = document.getElementById("pdfToPicId")
          pdfToPicId.style.height="3750px"
          let contractId =document.getElementById("contractId")
          contractId.style.height="4500px"
          let backgroundId =document.getElementById("backgroundId")
          backgroundId.style.height="5000px"

      },
      load(){
        let url =this.contractUrl
        if (this.$store.state.user.logined) {
          // window.location.href = url;
          window.open(url)
        } else {
          window.open("/Login?returnUrl=" + "/countyContract", "_blank");
        }
      },
      fileChange(){
            let fileId = document.getElementById("file");
            let files = fileId.files;
            let paperConfirmId = document.getElementById("paperConfirmId")
            console.log(files);
            if(files.length>0){
              this.isUpload=true
              this.fileName=files[0].name
              this.file=files[0]
              paperConfirmId.style.backgroundColor="#006699"
              paperConfirmId.style.cursor="pointer"
            }else{
              this.isUpload=false
              this.fileName=''
              this.file=[]
              paperConfirmId.style.backgroundColor="#CCCCCC"
            }
          },
      //用户确认电子合同
      confirmContract1(){
        let param = new FormData();
        param.append("orderId", this.requirementId);
        this.axios
            .post(
              "/tilesapi/tiles/register/confirmContract",
              param,
              {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }
            )
            .then((res) => {
              if(res.data.code==200){
                this.tip=2
              }else {
                this.tip=1
                alert("确认合同失败失败，请联系商务经理（0431-86008580）")
              }
              console.log(res.data)
            });
      },
      //用户确认纸质合同
      confirmContract2(){
        console.log(this.file);
        this.tip=2
        let formData = new FormData();
        formData.append("orderId", this.requirementId);
        formData.append("file", this.file);
        this.axios.post("/tilesapi/tiles/register/addPaperContract",formData,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            console.log(res.data)
            if(res.data.code==200){
              this.tip=2
            }else {
              this.tip=1
              alert("确认合同失败，请联系商务经理（0431-86008580）")
            }
        });
      },
      jumpToDetail(){
        this.$router.push({path: "/rsOrderDetail",query: {'orderId':this.requirementId}});
      },
      jumpToPay(){
        this.$router.push({name: "rsOrderPayment",params: {'orderId':this.requirementId}})

      },
    },
    mounted() {
      this.toPageTop()
      this.getContract()
      this.getStatusTime()
      if(this.eleOrPaper==0){
        let backgroundId =document.getElementById("backgroundId")
        backgroundId.style.height="1150px"
      }
    },
  };
  </script>
  <style scoped>
  .background {
    position:relative;
    margin-top: 76px;
    width: 100%;
    height: 1853px;
    background: #f5f5f6;
  }
  .goback{
    position: absolute;
    height: 18px;
    width: 60px;
    top: 62px;
    left: calc(50% - 640px);
    cursor: pointer;
}
.gobackText{
    position: absolute;
    left: 15px;
    width: 100px;
    height: 18px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 18px;
}
.greyText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 200px);
    width: 400px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.jindutiao{
    position: absolute;
    width: 1280px;
    height: 76px;
    top: 142px;
    left: calc(50% - 640px);
}
.jindutiaoText1{
    position: absolute;
    top: 35px;
    left: 242px;
    width: 76px;
height: 16px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 16px;
text-align: center;
}
.jindutiaoLine1{
   position: absolute;
   top: 14px;
   left: 292px;
   width: 155px;
    height: 1px;
    border-top: 2px solid #0066CC;
}
.jindutiaoLine2{
    position: absolute;
    top: 15px;
    left: 370px;
    width: 75px;
    height: 2px;
    border-top: 1px solid #CCCCCC;

}
.jindutiaoText2{
    position: absolute;
    left: 422px;
    top: 35px;
    width: 76px;
    height: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 16px;
    text-align: center;
}
.jindutiaoText3{
    position: absolute;
    left: 387px;
    top: 56px;
    width: 147px;
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 16px;
    text-align: center;

}
  .whiteStatus {
    position: absolute;
    width: 100%;
    height: 160px;
    background: #ffffff;
  }
  .whiteContent {
    position: absolute;
    width: 1280px;
    height: 160px;
    left: calc(50% - 640px);
    top: 0px;
  }
  .companyIcon {
    position: absolute;
    top: 45px;
    left: 0px;
  }
  .status1{
  position: absolute;
  width: 40px;
  height: 40px;
  top: 45px;
  left:620px;
  z-index: 1;
  }
  .status2{
  position: absolute;
  width: 15px;
  height: 12px;
  top: 59px;
  left: 633px;
  z-index: 2;
  }
  .statusText1{
    position: absolute;
    width:100px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 22px;
  top: 96px;
  left: 608px;
  }
  .statusText2{
    position: absolute;
    top: 118px;
    left: 749px;
    width: 86px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 17px;
  text-align: center;
  }
  .statusText3{
    position: absolute;
    width: 14px;
  height: 23px;
  font-size: 16px;
  font-family: Arial-Black, Arial;
  font-weight: 900;
  color: #FFFFFF;
  line-height: 23px;
  top: 53px;
  left: 939px;
  z-index: 2;
  }
  .line1{
    position: absolute;
    /* width: 115px; */
  top: 64px;
  left: 658px;
  /* z-index: 0; */
  }
  .contract {
    position: absolute;
    top: 274px;
    left: calc(50% - 640px);
    width: 1280px;
    height: 1350px;
    background: #ffffff;
    border-radius: 12px;
  }
  .contractIcon {
    position: absolute;
    width: 78px;
    height: 78px;
    top: 100px;
    left: calc(50% - 39px);
  }
  .text1 {
    position: absolute;
    top: 208px;
    width: 1280px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #3a3a3a;
    line-height: 28px;
    text-align: center;
  }
  .text2 {
    position: absolute;
    top: 262px;
    left: calc(50% - 400px);
    width: 800px;
    height: 60px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #3a3a3a;
    line-height: 30px;
    text-align: center;
  }
  .xuxian {
    position: absolute;
    top: 394px;
    left: 160px;
    width: 389px;
    padding: 10px;
    background: linear-gradient(
      to left,
      transparent 0%,
      transparent 50%,
      #979797 50%,
      #979797 100%
    );
    background-size: 10px 1px; /* 第一个参数控制虚线的间隙（利用的是图片的放大效果一样），第二个参数控制虚线的粗细 */
    background-repeat: repeat-x;
    background-position: top; /* 控制方向：top、bottom */
  }
  .text3 {
    position: absolute;
    top: 386px;
    left: 549px;
    width: 182px;
    height: 16px;
    font-size: 16px;
    font-family: STFangsong;
    color: #3a3a3a;
    line-height: 16px;
    text-align: center;
  }
  .checkIcon{
      position: absolute;
      top: 424px;
      width: 30px;
      height: 30px;
      left: calc(50% - 15px);
  }
  .shadow{
      position: absolute;
      top: 880px;
      width: 990px;
      height: 306px;
      left: calc(50% - 495px);
  }
  .checkContract{
      position: absolute;
      top: 1180px;
      left: calc(50% - 75px);
      width: 150px;
  height: 40px;
  background: #006699;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  }
  .pdfToPic {
    position: absolute;
    top: 472px;
    width: 960px;
    height: 660px;
    left: calc(50% - 480px);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
  .contentText1{
      position: absolute;
      top: 66px;
      padding-left:80px ;
      width: 960px;
      height: 17px;
      font-size: 16px;
      font-family: STFangsong;
      color: #3A3A3A;
      line-height: 16px;
  }
  .contentText2{
      position: absolute;
      top: 203px;
      width: 960px;
  height: 40px;
  font-size: 40px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 40px;
  text-align: center;
  }
  .contentText3{
      margin-top: 363px;
      margin-left: 80px;
      width: 880px;
  height: 20px;
  font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 20px;
  }
  .contentText4{
      margin-top: 20px;
      margin-left: 80px;
      width: 880px;
  height: 20px;
  font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 20px;
  }
  .contentText5{
      margin-top: 67px;
      margin-left: 80px;
      width:806px;
  height: auto;
  font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 28px;
  text-indent: 2em;
  text-align:justify;
  }
  .contentText6{
      margin-top: 20px;
      margin-left: 80px;
      width:806px;
  height: auto;
  font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  font-weight: 600;
  line-height: 20px;
  text-indent: 2em;
  }
  .contentText7{
      margin-top: 20px;
      margin-left: 80px;
      width:806px;
  height: auto;
  font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 20px;
  text-indent: 2em;
  }
  .contentText8{
    margin-left: 80px;
    height: auto;
    font-size: 20px;
    font-family: STFangsong;
    color: #3A3A3A;
    float:left;
    text-indent:0;
    font-weight: 600;
    margin-top: 20px;
    width: 370px;
    line-height: 35px;
  }
  .contentText9{
    margin-right: 80px;
    height: auto;
    font-size: 20px;
    font-family: STFangsong;
    color: #3A3A3A;
    float:right;
    text-indent:0;
    font-weight: 600;
    margin-top: 20px;
    width: 370px;
    line-height: 35px;
}
  .contentText10{
    float: left;
    margin-top:50px;
    margin-left: 80px;
    width: 806px;
    height: auto;
}
  .table1{
    margin-top: 10px;
    margin-left: 80px;
    width: 806px;
    background-color:rgb(204,204,204) ;
    height: auto;
    border: 1px solid #000000;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 34px;
  text-align: center;
  }
  .table2{
    float: left;
    margin-top: 0px;
    margin-left: 80px;
    width: 260px;
    height: auto;
    border: 1px solid #000000;
    border-top: none;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 34px;
  text-align: center;
  }
  .table3{
    float: left;
    margin-top: 0px;
    margin-left: 0px;
    width: 546px;
    height: auto;
    border: 1px solid #000000;
    border-top: none;
    border-left: none;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 34px;
  text-align: center;
  }
  .table4{
    float: left;
    margin-top: 0px;
    margin-left: 80px;
    width: 260px;
    height: 68px;
    border: 1px solid #000000;
    border-top: none;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 34px;
  text-align: center;
  }
  .table5{
    float: left;
    margin-top: 0px;
    margin-left: 0px;
    width: 546px;
    height: 68px;
    border: 1px solid #000000;
    border-top: none;
    border-left: none;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 34px;
  text-align: center;
  }
  .table6{
    float: left;
    margin-left: 80px;
    width: 161px;
    height: 60px;
    border: 1px solid #000000;
    border-right: none;
    font-size: 20px;
  font-family: STFangsong;
  color: #3A3A3A;
  line-height: 60px;
  text-align: center;
  }
  .table7{
    float: left;
    margin-top: 10px;
    margin-left: 80px;
    width: 805px;
    height: auto;
    border: 1px solid #000000;
  }
  .table7Text1{
    width: 161px;
    padding: 10px;
    font-size: 20px;
  font-family: STFangsong;
  border-right:1px solid #000000 ;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
  }
  .confirmContract{
    position: absolute;
      top: 4300px;
      left: calc(50% - 75px);
      width: 150px;
  height: 40px;
  background: #006699;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  }
  .contractTip{
    position: absolute;
    width: 1280px;
    left: calc(50% - 640px);
    bottom: 100px;
    text-align: center;
  }
  .contractDialog{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }
  .shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
  .white1{
    position: absolute;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #ffffff;
    border-radius: 12px;
  }
  .diglogText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 400px);
    width:800px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
  }
  .diglogText2{
    position: absolute;
    top: 175px;
    left: calc(50% - 300px);
    width: 600px;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 30px;
  text-align: center;
  }
  .diglogText3{
    position: absolute;
    top: 115px;
    left: 74px;
    width: 660px;
  height: 120px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 30px;
  text-align: left;
  }
  .dialog1Button1{
    position: absolute;
    top: 310px;
    left: 262px;
    width: 128px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #336699;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #336699;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  }
  .dialog1Button2{
    position: absolute;
    top: 310px;
    left: 410px;
    width: 128px;
  height: 40px;
  border-radius: 6px;
  background: #336699;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  }
  .contractPaper {
    position: absolute;
    top: 260px;
    left: calc(50% - 640px);
    width: 1280px;
  height: 668px;
    background: #ffffff;
    border-radius: 12px;
  }
  .downloadContract{
    position: absolute;
    top: 458px;
    left: calc(50% - 64px);
    width: 128px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #336699;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #336699;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  }
  .paperText1{
    position: absolute;
    top: 538px;
    left: 727px;
    width: 600px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 20px;
  }
  .fileUpload{
    position: absolute;
        top: 263px;left:336px;
        width: 130px;
       height:20px;
       background-color: pink;
       opacity: 0;
    cursor: pointer;
    box-sizing: border-box;
    padding: 13px;
    z-index: 1;
  }
  .paperIcon{
    position: absolute;
    top: 268px;
    left:339px;
    width: 14px;
    height: 14px;

  }
  .paperText{
    position: absolute;
    top: 265px;
    left: 363px;
    width:120px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006699;
  line-height: 20px;
  }
  .paperText2{
    position: absolute;
    top: 265px;
    left: calc(50% - 400px);
    width:800px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006699;
  line-height: 20px;
  text-align: center;
  }
  .paperConfirm{
  position: absolute;
  top: 310px;
  left: calc(50% - 64px);
  width: 128px;
  height: 40px;
  background: #CCCCCC;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  }
  .footerWhite{
    position: relative;
    width: 100%;
    height: 120px;
    background: #FFFFFF;
}
.text {
  position: absolute;
  top: 50px;
  left: calc(50% - 350px);
  width: 700px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 17px;
  text-align: center;
}
  </style>
